import { Route, Routes } from "react-router-dom";
import UpdateStudentProgress from "../updateStudentProgress/UpdateStudentProgress";
import StudentProgress from "../studentProgress/StudentProgress";
import Baseline from "../baseline/Baseline";
import Notes from "../notes/Notes";
import EditDetails from "../editDetails/EditDetails";
import PortalStudent from "../../layouts/PortalStudent";
import Feedback from "../feedback/Feedback";

const Students = () => {
    return (
        <PortalStudent>
            <Routes>
                <Route path="update-student-progress" element={<UpdateStudentProgress />} />
                <Route path="progress-tracking" element={<StudentProgress />} />
                <Route path="baseline" element={<Baseline />} />
                <Route path="notes" element={<Notes />} />
                <Route path="edit-details" element={<EditDetails />} />

                <Route path="/feedback/:feedback_form_id" element={<Feedback />} />
            </Routes>
        </PortalStudent>
    );
}

export default Students;